import { Injectable } from "@angular/core";
import { firstValueFrom, Observable } from "rxjs";
import * as _ from 'lodash';
import { ITaskRequest } from "./task-requests.interface";
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { AuthService } from "../../../shared/services/auth.service";
import { IFilter } from "../../../shared/interfaces/filter.interface";
import { apiURL, EnvConfig } from "../../../../env-config";


@Injectable()
export class TaskRequestsService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
    private _AuthService: AuthService,
  ) { }

  async getTaskRequestsCount() {
    const filter: IFilter = {
      company: this._AuthService.companyId(),
      limit: 10000,
      filters: {
        status: 'PENDING'
      }
    }
    return (await firstValueFrom(this.getTaskRequests(filter))).length;
  }

  getTaskRequests(filter?: IFilter): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_TASK_REQUESTS)}${queryParams}`);
  }

  getTaskRequest(taskRequest: ITaskRequest | string): Observable<any> {
    let id = (typeof taskRequest == 'string') ? taskRequest : taskRequest._id;
    return this._http.get(`${apiURL(EnvConfig.API_TASK_REQUESTS)}/${id}`);
  }

  createTaskRequest(taskRequest: ITaskRequest): Observable<any> {
    return this._http.post(`${apiURL(EnvConfig.API_TASK_REQUESTS)}`, taskRequest);
  }

  updateTaskRequest(taskRequest: any): Observable<any> {
    let id = taskRequest._id;
    delete taskRequest._id;
    return this._http.patch(`${apiURL(EnvConfig.API_TASK_REQUESTS)}/${id}`, taskRequest);
  }

  deleteTaskRequest(taskRequest: ITaskRequest | string, hardDelete: boolean = false): Observable<void> {
    let id = (typeof taskRequest == 'string') ? taskRequest : taskRequest._id;
    if (hardDelete) return this._http.delete(`${apiURL(EnvConfig.API_TASK_REQUESTS)}/${id}`);
    return this._http.delete(`${apiURL(EnvConfig.API_TASK_REQUESTS)}/${id}/delete`);
  }

  restoreTaskRequest(taskRequest: ITaskRequest | string): Observable<void> {
    let id = (typeof taskRequest == 'string') ? taskRequest : taskRequest._id;
    return this._http.post(`${apiURL(EnvConfig.API_TASK_REQUESTS)}/${id}/restore`, null);
  }
}